import { useMemo } from 'react';
import { ChevronIcon } from '@ui/kit/icons';
import { sentenceInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { wrapper, container, inputWithChevronContainer } from './container.print.style.js';
import { SentenceInput } from './input.content.js';
import { orderInputs } from './util.order-inputs.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function PrintContainer(props) {
  const inputEntries = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).map(([key, value]) => {
      const typedValue = sentenceInput.entry.asTypeSafe(value);
      if (typedValue) {
        return {
          nodeId: key,
          ...typedValue
        };
      }
    }).filter(it => !!it)
  });
  const userOrderedInputs = useMemo(() => orderInputs(props.task.content, inputEntries), [inputEntries, props.task.content]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx("div", {
      className: wrapper,
      children: /*#__PURE__*/jsx("div", {
        className: container,
        children: userOrderedInputs.map((input, index) => /*#__PURE__*/jsxs("div", {
          className: inputWithChevronContainer,
          children: [/*#__PURE__*/jsx(SentenceInput, {
            node: input,
            taskEntryKey: props.taskEntryKey
          }), index !== userOrderedInputs.length - 1 && /*#__PURE__*/jsx(ChevronIcon, {
            height: 8,
            strokeWidth: 3
          })]
        }, input.id))
      })
    })
  });
}

export { PrintContainer };
//# sourceMappingURL=container.print.js.map
